import React, { Component } from 'react';

class CustomProgress extends Component {
    // constructor(props) {
    //     super(props);
    // }

    componentDidMount() {

    }

    getPercentValue() {
        const { total, active } = this.props;
        if (total > 0) {
            const percent = (active * 100) / total;
            return Math.round(percent) + "%";
        } else {
            return 0 + "%";
        }
    }

    render() {
        const { title, total, active } = this.props;

        return (
            <div className="col-12 col-md-4 mt-3">
                <h6 className="text-white font-weight-medium d-flex">{title}
                    <span className="ml-auto">{active}/{total}</span>
                </h6>
                <div className="progress progress-red1" style={{ paddingRight: "0px" }}>
                    <div className={`progress-bar ${active === 0 ? "progress-padding" : ''} `} role="progressbar" style={{ width: this.getPercentValue() }} aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                        {this.getPercentValue()}
                    </div>
                </div>
            </div>
        )
    }
}

export default CustomProgress;
